import { useState, useEffect } from "react";
import { useBLEforAquapilotWeb } from "./hooks/useBle";

function App() {
  const {
    scanForLifeguard,
    connectToDevice,
    disconnectFromDevice,
    sendWifiCredentials,
    connectedDevice,
    isConnected,
    loading,
  } = useBLEforAquapilotWeb();

  const [ssid, setSsid] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  useEffect(() => {
    if (connectedDevice && !isConnected) {
      connectToDevice(connectedDevice).catch((error) => {
        console.error("Error connecting to device:", error);
      });
    }
  }, [connectedDevice, isConnected]);

  const handleSendWifi = async () => {
    if (connectedDevice && isConnected) {
      try {
        const server = await connectedDevice.gatt?.connect();
        if (!server) {
          console.error("Failed to get GATT server");
          return;
        }

        const UUID_WIFI_SERVICE = "ff00c161-5d1a-4c5d-83f6-0671df21574d";
        const UUID_CHAR_WIFI_SSID = "0000ff02-0000-1000-8000-00805f9b34fb";
        const UUID_CHAR_WIFI_PASSWORD = "0000ff04-0000-1000-8000-00805f9b34fb";
        const UUID_CHAR_WIFI_ENC_METHOD =
          "0000ff03-0000-1000-8000-00805f9b34fb";

        // Chamando a função para enviar SSID e senha
        await sendWifiCredentials(
          server,
          UUID_WIFI_SERVICE,
          UUID_CHAR_WIFI_SSID,
          UUID_CHAR_WIFI_PASSWORD,
          UUID_CHAR_WIFI_ENC_METHOD,
          ssid,
          password
        );

        // Auto disconnect after sending WiFi credentials
        await disconnectFromDevice();
      } catch (error) {
        console.error("Error sending WiFi credentials:", error);
      }
    } else {
      alert("Please connect to a device first.");
    }
  };

  const handleScanAndConnectOrDisconnect = async () => {
    if (isConnected) {
      try {
        await disconnectFromDevice();
      } catch (error) {
        console.error("Error disconnecting from device:", error);
      }
    } else {
      try {
        await scanForLifeguard();
      } catch (error) {
        console.error("Error during scan and connect:", error);
      }
    }
  };

  return (
    <div className="App">
      <h1 style={{ fontFamily: 'Noto Sans', color: '#ffd200', fontSize: '5rem', textAlign: 'center', margin: '2rem 0' }}>Davey Lifeguard</h1>
      <div className="top-buttons-container">
        <button
          className="top-button"
          style={{
            width: "100%",
            backgroundColor: loading ? "gray" : "",
            pointerEvents: loading ? "none" : "auto",
          }}
          onClick={handleScanAndConnectOrDisconnect}
          disabled={loading}
        >
          {isConnected ? "Disconnect" : "Scan and Connect"}
        </button>
      </div>

      <div>
        <h3>Send WiFi Credentials</h3>
        <input
          type="text"
          placeholder="Enter WiFi SSID"
          value={ssid}
          onChange={(e) => setSsid(e.target.value)}
          disabled={!isConnected}
          style={{ backgroundColor: !isConnected ? "lightgray" : "" }}
        />
        <input
          type="password"
          placeholder="Enter WiFi Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={!isConnected}
          style={{ backgroundColor: !isConnected ? "lightgray" : "" }}
        />
        <button
          onClick={handleSendWifi}
          disabled={!isConnected || loading}
          style={{
            backgroundColor: (!isConnected || loading) ? "gray" : "",
            pointerEvents: (!isConnected || loading) ? "none" : "auto",
          }}
        >
          Send WiFi Credentials
        </button>
      </div>

      <div>
        <h3>Status:</h3>
        <p>
          {isConnected
            ? `Connected to ${connectedDevice?.name}`
            : "Not connected"}
        </p>
      </div>

      {/* Information Box Disclaimer */}
      <div style={{
        margin: '2rem auto',
        maxWidth: 600,
        background: '#fffbe6',
        border: '1px solid #ffd200',
        borderRadius: 8,
        padding: '1.5rem',
        color: '#333',
        fontSize: '1.1rem',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
      }}>
        <strong>Disclaimer:</strong> Web Bluetooth works on most Chromium-based browsers on Android, Windows, and macOS. <br />
        For iOS, please download <a href="https://apps.apple.com/au/app/bluefy-web-ble-browser/id1492822055" target="_blank" rel="noopener noreferrer">Bluefy</a> from the App Store to use Bluetooth features.
      </div>
    </div>
  );
}

export default App;
